<div class="builder-container">
  <form [formGroup]="formatAllForm">
    <div class="col">
      <p>Apply to all:</p>
      <mat-checkbox color="primary" formControlName="caption"
        >Caption (all italics)</mat-checkbox
      >
      <mat-checkbox color="primary" formControlName="prompt"
        >Discussion prompt (all blue)</mat-checkbox
      >
      <mat-checkbox color="primary" formControlName="header"
        >Header (all bold)</mat-checkbox
      >
    </div>
  </form>
  <div class="player-container">
    <app-karaoke-player
      [block]="block"
      [karaoke]="formattedKaraokePlayer"
    ></app-karaoke-player>
  </div>
  <ng-container *ngIf="form">
    <button
      class="reset-button header-text"
      mat-raised-button
      color="primary"
      (click)="resetTranscript()"
    >
      {{ ' Reset' | uppercase }}
    </button>
    <form [formGroup]="form">
      <div class="wordlist-container">
        <ng-container
          formArrayName="transcriptWordList"
          *ngFor="let block of transcriptWordList?.controls; let i = index"
        >
          <ng-container *ngIf="this.block.get('content').value">
            <ng-container [formGroupName]="i">
              <div class="word-container">
                <input [formControlName]="'content'" />
                <button
                  class="menu-button"
                  mat-button
                  [matMenuTriggerFor]="beforeMenu"
                  aria-label="Word Formatting Options"
                >
                  <mat-icon
                    color="primary"
                    fontSet="material-icons-outlined"
                    matTooltip="Formatting Menu"
                    aria-label="Word Formatting Options"
                    aria-hidden="false"
                    >add_circle_outline</mat-icon
                  >
                </button>
                <mat-menu
                  class="formatting-menu"
                  #beforeMenu="matMenu"
                  xPosition="before"
                >
                  <div class="menu-container">
                    <button
                      class="menu-button"
                      mat-button
                      (closeMenu)="closeFormattingMenu()"
                    >
                      <mat-icon
                        color="primary"
                        fontSet="material-icons-outlined"
                        matTooltip="Close Menu"
                        aria-label="Word Formatting Options"
                        aria-hidden="false"
                        >remove_circle_outline</mat-icon
                      >
                    </button>
                    <div class="checkbox-container">
                      <ng-container
                        *ngFor="
                          let checkbox of formattingCheckboxList;
                          trackBy: 'id' | trackByKey
                        "
                      >
                        <mat-checkbox
                          color="primary"
                          [formControlName]="checkbox.link"
                          (click)="$event.stopPropagation()"
                          >{{ checkbox.label }}</mat-checkbox
                        >
                      </ng-container>
                    </div>
                  </div>
                </mat-menu>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </form>
  </ng-container>
</div>
